// import parent theme JS
// eslint-disable-next-line import/no-unresolved
import 'swiper/swiper-bundle.min.css';
import '../scss/base.scss'; // styles
import main from '../../../../assets/js/_main';

document.addEventListener('DOMContentLoaded', () => {
  main();

  window.s1.alpine.start();
});
